import { useMutation, useQueryClient } from '@tanstack/react-query'

import { api } from '@/utils/api'
import type { TeamMember } from '@/types'

type Args = {
  teamId: string
  userIds: string[]
}

export const useAddTeamMember = () => {
  const queryClient = useQueryClient()

  return useMutation<TeamMember, Error, Args>({
    mutationFn: async ({ teamId, userIds }) => {
      const { data } = await api.post(`/teams/${teamId}/members`, { userIds })
      return data.data
    },
    onSuccess: (_, args) => {
      queryClient.invalidateQueries({
        queryKey: ['team-members', args.teamId],
      })
    },
  })
}
